import { SCREENING_CONST } from '@/const';
import SearchCentersClass from './SearchCenters.model';

export default class ScreeningCenters extends SearchCentersClass {
  static moreFilter(center, filters) {
    let { show } = center;
    const { testTypes, prioType } = filters;

    if (prioType && prioType !== '0') {
      const { apiValue } = SCREENING_CONST.CENTERS_TYPES.find(({ value }) => value === prioType);
      show = !!apiValue.find((elem) => elem.toLowerCase().indexOf(center.getEntityType()?.toLowerCase()) !== -1);
    }

    if (show) {
      const testTypesArr = testTypes?.join('')?.toLowerCase();
      if (!testTypesArr) return false;

      show = center.getTestTypes()?.find((type) => testTypesArr?.indexOf(type?.toLowerCase()) !== -1);
    }

    return show;
  }

  clone() {
    return new ScreeningCenters(this.serverData);
  }
}
